import { useEffect, useRef } from 'react';

/**
 * usePolling(callback, intervalMs, enabled)
 *
 * Runs `callback` every `intervalMs` while the tab is visible, and once
 * immediately when the tab becomes visible again. Pairs with useFetch's
 * `refetch({ silent: true })` so background refreshes don't flash spinners.
 */
export default function usePolling(callback, intervalMs, enabled = true) {
    const savedCallback = useRef(callback);

    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    useEffect(() => {
        if (!enabled || !intervalMs) return undefined;

        const tick = () => {
            if (document.visibilityState === 'visible') {
                savedCallback.current();
            }
        };
        const intervalId = setInterval(tick, intervalMs);
        document.addEventListener('visibilitychange', tick);

        return () => {
            clearInterval(intervalId);
            document.removeEventListener('visibilitychange', tick);
        };
    }, [intervalMs, enabled]);
}
